import { render, staticRenderFns } from "./admin_log_index.vue?vue&type=template&id=533ce6e0"
import script from "./admin_log_index.vue?vue&type=script&lang=js"
export * from "./admin_log_index.vue?vue&type=script&lang=js"
import style0 from "./admin_log_index.vue?vue&type=style&index=0&id=533ce6e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports